
import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import HistoryIcon from "@mui/icons-material/History";
import CoachHistoryDialog from "./CoachHistoryDialog";

export default function CoachHistorySearch() {
  const [searchCoachNo, setSearchCoachNo] = useState("");
  const [selectedCoachNo, setSelectedCoachNo] = useState("");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();

    const coachNo = searchCoachNo.trim().toUpperCase();

    if (!coachNo) {
      setError("Please enter a coach number");
      return;
    }

    setError("");
    setSelectedCoachNo(coachNo);
    setOpen(true);
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <Card elevation={2} sx={{ maxWidth: 750, mx: "auto" }}>
        <CardContent>
          <Stack spacing={2}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <HistoryIcon color="primary" fontSize="large" />
              <Box>
                <Typography variant="h6" fontWeight={700}>
                  Coach History Search
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Search complete history using coach number
                </Typography>
              </Box>
            </Stack>

            <Box component="form" onSubmit={handleSearch}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1}
              >
                <TextField
                  fullWidth
                  size="small"
                  label="Coach Number"
                  placeholder="Enter coach number"
                  value={searchCoachNo}
                  onChange={(e) => {
                    setSearchCoachNo(e.target.value);
                    setError("");
                  }}
                  error={Boolean(error)}
                  helperText={error}
                  autoComplete="off"
                />

                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  sx={{ minWidth: { sm: 140 } }}
                >
                  Search
                </Button>
              </Stack>
            </Box>
          </Stack>
        </CardContent>
      </Card>

      {selectedCoachNo && (
        <CoachHistoryDialog
          coachNo={selectedCoachNo}
          open={open}
          onClose={() => setOpen(false)}
        />
      )}
    </Box>
  );
}
